import { Loader2 } from 'lucide-react';
import type { PaginationMeta } from '../../types/admin';

interface PaginationProps {
  pagination: PaginationMeta | null | undefined;
  onPageChange: (page: number) => void;
  /** Noun for the total, e.g. "users". */
  label?: string;
  isFetching?: boolean;
}

/** Footer pager for admin tables (extracted from the original AdminUsers page). */
export default function Pagination({ pagination, onPageChange, label = 'items', isFetching }: PaginationProps) {
  const page = pagination?.page ?? 1;
  const totalPages = Math.max(1, pagination?.totalPages ?? 1);
  const total = pagination?.total ?? 0;

  return (
    <div className="flex items-center justify-between border-t border-glass px-4 py-3 text-sm text-glass-text-2">
      <span className="flex items-center gap-2">
        Page {page} of {totalPages} ({total.toLocaleString()} {label})
        {isFetching && <Loader2 className="h-3.5 w-3.5 animate-spin text-glass-text-3" aria-label="Loading" />}
      </span>
      <div className="flex gap-2">
        <button
          type="button"
          onClick={() => onPageChange(Math.max(1, page - 1))}
          disabled={page <= 1}
          className="btn-glass px-3 py-1.5 text-sm disabled:opacity-50"
        >
          Previous
        </button>
        <button
          type="button"
          onClick={() => onPageChange(Math.min(totalPages, page + 1))}
          disabled={page >= totalPages}
          className="btn-glass px-3 py-1.5 text-sm disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
}
